import { useContext } from 'react';

import { DataContext } from './data';

export default function useDataContext() {
    const dataContext = useContext(DataContext);

    return dataContext;
}